import React from 'react';
import cx from 'classnames';

const propTypes = {};

const CLASS_ROOT = 'container';

const Container = ({ className, ...other }) => {
  const classes = cx(CLASS_ROOT, className);

  return <div className={classes} {...other} />;
};

Container.displayName = 'Container';
Container.propTypes = propTypes;

export default Container;



// WEBPACK FOOTER //
// ./src/components/Grid/Container.js